import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/orders/all')({
  staticData: {
    title: 'route.orders.all',
    crumb: 'route.orders.all',
    permissions: ['orders_all_view'],
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
